<template>
    <div id="eleven">
        <ul>
            <li @click="active = 10">
                <div :class="{active:active == 10}">
                    <h4>充11元</h4>
                    <p>送 <span>11</span> 元</p>
                    <p>共计2200个</p>
                    <p>书币+书豆</p>
                </div>
            </li>
            <li @click="active = 11">
                <div :class="{active:active == 11}">
                    <h4>充51元</h4>
                    <p>送 <span>61</span> 元</p>
                    <p>共计11200个</p>
                    <p>书币+书豆</p>
                </div>
            </li>
            <li @click="active = 12">
                <div :class="{active:active == 12}">
                    <h4>充111元</h4>
                    <p>送 <span>189</span> 元</p>
                    <p>共计30000个</p>
                    <p>书币+书豆</p>
                </div>
            </li>
        </ul>
        <button @click="doRecharge">立即购买</button>
        <p class="tip">活动时间：11月8日-11月12日</p>
    </div>
</template>

<script>
    export default {
        name: "Eleven",
        data(){
            return {
                active : 11
            }
        },
        methods : {
            doRecharge(){
                if(this.active < 10){
                    alert("请选择充值选项！");
                    return;
                }
                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : 4,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        },
        created() {
            //Eleven

        }

    }
</script>

<style lang="less">
#eleven{
    width: 100%;height: 1500px;background: url("./../../assets/images/11bg.png");background-size: 100% 100%;
    padding-top: 900px;
    ul{height:320px;display: flex;padding: 0 10px;
        li{flex:1;padding: 0 10px;
            div{height: 100%;
                background: url("./../../assets/images/11q.png");background-size: 100% 100%;
                color: #b700d4;text-shadow:#fff 1px 0 0,#fff 0 1px 0,#fff -1px 0 0,#fff 0 -1px 0;text-align: center;
                padding-top: 40px;
                h4{font-size: 40px;}
                p{line-height: 70px;font-size: 30px;
                    span{font-size: 60px;font-weight: 700;}
                }
            }
            div.active{color: orangered;}

        }
    }
    button{border: 1px solid #feef39;background: none;color: #feef39;padding: 10px 80px;font-size: 30px;border-radius: 50px;display: block;
        margin: 30px auto;}
    .tip{font-size: 30px;color: #feef39;text-align: center;}


}
</style>
